import { render, staticRenderFns } from "./ChatBox.vue?vue&type=template&id=5fc2f184&scoped=true&"
import script from "./ChatBox.vue?vue&type=script&lang=js&"
export * from "./ChatBox.vue?vue&type=script&lang=js&"
import style0 from "./ChatBox.vue?vue&type=style&index=0&id=5fc2f184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc2f184",
  null
  
)

export default component.exports